// extracted by mini-css-extract-plugin
export var checkbox = "_9p-0";
export var circle = "_9p-3";
export var horizontalContainer = "_9p-7";
export var sm = "_9p-5";
export var switch0 = "_9p-2";
export var switchDisabled = "_9p-8";
export var switchEnabled = "_9p-1";
export var textSwitchContainer = "_9p-9";
export var textSwitchOption = "_9p-a";
export var textSwitchOptionSelected = "_9p-b";
export var verticalContainer = "_9p-6";
export var xs = "_9p-4";